export class DeferredPromise {
    constructor(existingPromise) {
        this.resolve = () => { };
        this.reject = () => { };
        this._promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
            if (existingPromise) {
                existingPromise.then(resolve).catch(reject);
            }
        });
        this.then = this._promise.then.bind(this._promise);
        this.catch = this._promise.catch.bind(this._promise);
        this.finally = this._promise.finally.bind(this._promise);
        this[Symbol.toStringTag] = "Promise";
    }
}
//# sourceMappingURL=types.js.map